import React from "react"
import { renderCards } from "../../hooks/usePersonCards"

const PersonCards = () => {
  return <>{renderCards()}</>
}

export default PersonCards
